const getters = {
  // language: state => state.app.language,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js